import { isArray } from "@visactor/vutils";

import { getTheme } from "../../../graphic/theme";

import { POLYGON_NUMBER_TYPE } from "../../../graphic/constants";

import { drawPolygon, drawRoundedPolygon } from "../../../common/polygon";

import { BaseRender } from "./base-render";

import { defaultPolygonBackgroundRenderContribution, defaultPolygonTextureRenderContribution } from "./contributions/polygon-contribution-render";

export class DefaultCanvasPolygonRender extends BaseRender {
    constructor(graphicRenderContributions) {
        super(), this.graphicRenderContributions = graphicRenderContributions, this.numberType = POLYGON_NUMBER_TYPE, 
        this.builtinContributions = [ defaultPolygonBackgroundRenderContribution, defaultPolygonTextureRenderContribution ], 
        this.init(graphicRenderContributions);
    }
    drawShape(polygon, context, x, y, drawContext, params, fillCb, strokeCb) {
        const polygonAttribute = getTheme(polygon, null == params ? void 0 : params.theme).polygon, {points: points = polygonAttribute.points, cornerRadius: cornerRadius = polygonAttribute.cornerRadius, x: originX = polygonAttribute.x, y: originY = polygonAttribute.y, closePath: closePath = polygonAttribute.closePath, fillStrokeOrder: fillStrokeOrder = polygonAttribute.fillStrokeOrder} = polygon.attribute, data = this.valid(polygon, polygonAttribute, fillCb, strokeCb);
        if (!data) return;
        const {fVisible: fVisible, sVisible: sVisible, doFill: doFill, doStroke: doStroke} = data;
        context.beginPath(), cornerRadius <= 0 || isArray(cornerRadius) && cornerRadius.every((num => 0 === num)) ? drawPolygon(context.camera ? context : context.nativeContext, points, x, y) : drawRoundedPolygon(context.camera ? context : context.nativeContext, points, x, y, cornerRadius, closePath), 
        closePath && context.closePath(), context.setShadowBlendStyle && context.setShadowBlendStyle(polygon, polygon.attribute, polygonAttribute), 
        this.beforeRenderStep(polygon, context, x, y, doFill, doStroke, fVisible, sVisible, polygonAttribute, drawContext, fillCb, strokeCb);
        const _runFill = () => {
            doFill && (fillCb ? fillCb(context, polygon.attribute, polygonAttribute) : fVisible && (context.setCommonStyle(polygon, polygon.attribute, originX - x, originY - y, polygonAttribute), 
            context.fill()));
        }, _runStroke = () => {
            doStroke && (strokeCb ? strokeCb(context, polygon.attribute, polygonAttribute) : sVisible && (context.setStrokeStyle(polygon, polygon.attribute, originX - x, originY - y, polygonAttribute), 
            context.stroke()));
        };
        fillStrokeOrder ? (_runStroke(), _runFill()) : (_runFill(), _runStroke()), this.afterRenderStep(polygon, context, x, y, doFill, doStroke, fVisible, sVisible, polygonAttribute, drawContext, fillCb, strokeCb);
    }
    draw(polygon, renderService, drawContext, params) {
        const polygonAttribute = getTheme(polygon, null == params ? void 0 : params.theme).polygon;
        this._draw(polygon, polygonAttribute, !1, drawContext, params);
    }
}
//# sourceMappingURL=polygon-render.js.map
